import request from "@/common/request/request";
import {handleRes} from "@vUtils";

interface HandleResInterface {
  success: any,
      fail: any,
}

const board = {
  getBoardTop5: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardShipmentTop5(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getStatistics: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardDashboardStatistics(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getMonthTrend: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardBindMonthTrend(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getCenterMapData: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardDistribute(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getBoardCompany: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardCompany(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getBoardCompanyRegion: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardCompanyRegion(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getBoardRegionDeviceList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardRegionDeviceList(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getCityByProvince: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardRegionCityDevice(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getCompanyByCity: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardRegionCityCompanyDevice(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },
  getCityCompanyList: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardRegionCityCompanyDeviceGroup(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },

  getDeviceListByProvince: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETBoardRegionCityCompanyDeviceList(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },

  getUserBoardConfig: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.GETAccUserConfig(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },

  saveUserBoardConfig: (params: any): Promise<HandleResInterface> => {
    return new Promise(async (resolve) => {
      const res = await request.POSTAccUserConfig(params);
      const result = handleRes(res, {
        failMes: res.msg
      });
      resolve(result);
    });
  },

};

export default board;
